"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyledComponent = exports.useStyling = void 0;
const atoz_web_1 = require("@amzn/atoz-web");
const react_1 = require("react");
const getUpdatedSelectors = (originalSelectors) => {
    const selectors = Object.assign(Object.assign({}, originalSelectors), { fontFamily: (fontKey) => {
            let fontFamily = originalSelectors.fontFamily(fontKey);
            if (!fontFamily) {
                // Stencil Native uses font names like `monospace.light`
                // but in Web we don't have such so just grab first part
                fontFamily = originalSelectors.fontFamily(fontKey.split('.')[0]);
            }
            return fontFamily || undefined;
        } });
    return selectors;
};
const useStyling = (styler) => {
    const { theme, selectors } = (0, react_1.useContext)(atoz_web_1.StencilContext);
    return styler({ theme, selectors: getUpdatedSelectors(selectors) });
};
exports.useStyling = useStyling;
const useStyledComponent = (component, options) => {
    const styledComponent = (0, atoz_web_1.styledWithTheme)(component, options);
    return (componentStyler) => styledComponent((_a) => {
        var { theme } = _a, props = __rest(_a, ["theme"]);
        const updatedTheme = Object.assign({}, theme);
        updatedTheme.selectors = getUpdatedSelectors(theme.selectors);
        // Couldn't manage to write types correctly so using `any` for now
        return componentStyler(Object.assign(Object.assign({}, props), { theme: updatedTheme }));
    });
};
exports.useStyledComponent = useStyledComponent;
//# sourceMappingURL=styling.js.map